import { Overrides } from '@material-ui/core/styles/overrides'

import { masmovilPalette, llamayaPalette } from './colors'

export const masmovilCircularProgressOverride: Overrides = {
  MuiCircularProgress: {
    colorPrimary: {
      color: masmovilPalette.secondary.main,
    },
  },
}

export const llamayaCircularProgressOverride: Overrides = {
  MuiCircularProgress: {
    root: {
      color: llamayaPalette.secondary.main,
    },
  },
}
